import React, { useCallback, useEffect, useImperativeHandle, useState } from 'react';
import { connect, useDispatch } from "react-redux";
import styles from "./PostcodeForm.styles";
import {
  Box,
  Divider,
  FormControl,
  InputAdornment,
  Autocomplete,
} from "@mui/material";
import StyledTextField from "../styled-components/StyledTextField";
import SearchIcon from "@mui/icons-material/Search";
import InputHelperText from "../styled-components/InputHelperText";
import {
  receivePostcodeRequest,
  resetPostcode,
} from "../../../modules/add-new-entity/actions";
import { createEntity } from "../../../modules/add-new-entity/selectors";
import {
   initialErrorEditState
} from '../entity-editor/entity-editor-blocks/EntityAddressBlock';
import type { RootState } from '../../../reducers';

type PostcodeFormProps = {
  addressPostcode?: any;
  selectAddress?: (...args) => any;
  address?: {
    city_id: number | string;
    city: string;
    postcode: string;
    street_name: string;
    number: string;
    number_add: number;
    address: any;
  };
  type?: string;
  errorFields?: any,
  setErrorFields?: any,
};

type ValueType = {
  city: string;
  postcode: string;
  number: string;
  street: string;
  letter: string;
  addition: string;
};

type DefaultValueType = null;

export type PostcodeFormHandle = {
  reset: () => void;
}

const PostcodeForm = React.forwardRef<PostcodeFormHandle, PostcodeFormProps>(({
  addressPostcode,
  selectAddress,
  address,
  type,
  errorFields,
  setErrorFields,
}, ref) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState<ValueType | DefaultValueType>(null);
  const [inputValue, setInputValue] = useState("");
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any[]>([]);

  const reset = useCallback(() => {
    setValue(null);
    setInputValue("");
    setOpen(false);
    setOptions([]);
  }, [])
  useImperativeHandle(ref, () => ({reset}), [reset]);

  useEffect(() => {
    let active = true;
    let newOptions: any = [];

    if (inputValue === "") {
      setOptions(value ? [value] : []);
      return undefined;
    }
    if (active) {
      if (value) {
        newOptions = [value];
      }
      if (addressPostcode?.length) {
        newOptions = [...newOptions, ...addressPostcode];
      }
      setOptions(newOptions);
    }

    return () => {
      active = false;
    };
  }, [dispatch, value, addressPostcode, inputValue]);

  const handleChange = (newInputValue: string) => {

    setInputValue(newInputValue);
    if (newInputValue.length >= 6 && newInputValue.length <= 12) {
      const requestData = {
        inputValue: newInputValue,
      };
      dispatch(resetPostcode());
      if (value === null) {
        dispatch(receivePostcodeRequest(requestData));
      }
    }
  };

  useEffect(() => {
    if (value && address && type === "entity") {
      selectAddress &&
        selectAddress({
          ...address,
          city_name: value.city || "",
          postcode: value.postcode || "",
          street_name: value.street || "",
          number: value.number || "",
          number_add: `${value.letter ? value.letter : ""}${
            value.addition ? value.addition : ""
          }`,
        });
      setErrorFields(initialErrorEditState);
      return;
    }
    if (value && address && type === "object") {
      selectAddress &&
        selectAddress({
          ...address,
          address: {
            ...address.address,
            city_id: address.city_id || "",
            city_name: value.city || "",
            street_name: value.street || "",
            number: value.number || "",
            number_add:
              `${value.letter ? value.letter : ""}${
                value.addition ? value.addition : ""
              }` || "",
            postcode: value.postcode || "",
          },
        });
    }

    if (value && address && type === "objectUnit") {

      selectAddress &&
      selectAddress({
        ...address,
        address: {
          ...address.address,
          street_name: value.street || "",
          number: value.number || "",
          number_add:
            `${value.letter ? value.letter : ""}${
              value.addition ? value.addition : ""
            }` || "",
          postcode: value.postcode || "",
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <React.Fragment>
      <Box sx={styles.fieldBlock} component="form">
        <FormControl sx={styles.form} error={!!(inputValue && !value)}>
          <Autocomplete
            id="postcode"
            open={open && inputValue.length >= 6}
            onOpen={() => {
              setOpen(true);
            }}
            onClose={() => {
              setOpen(false);
            }}
            fullWidth
            freeSolo
            filterOptions={(x) => x}
            autoComplete
            includeInputInList
            filterSelectedOptions

            value={value}
            onChange={(_event, newValue: {}) => {
              // @ts-ignore
              setValue(newValue);
            }}
            clearOnEscape={true}
            inputValue={inputValue}
            onInputChange={(_e, newInputValue) => handleChange(newInputValue)}
            options={options}
            getOptionLabel={(option) =>
              `${option.postcode ? option.postcode : ""} ${
                option.city ? option.city : ""
              }, ${option.street ? option.street : ""} ${
                option.number ? option.number : ""
              } ${option.letter ? option.letter : ""} ${
                option.addition ? option.addition : ""
              }`
            }
            renderInput={(params) => (
              <StyledTextField
                {...params}
                variant="standard"
                margin="dense"
                error={!!(inputValue && !value)}
                slotProps={{
                  input: {
                    ...params.InputProps,
                    startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                    ),
                  },
                }}
                // InputProps={{
                //   ...params.InputProps,
                //   startAdornment: (
                //     <InputAdornment position="start">
                //       <SearchIcon />
                //     </InputAdornment>
                //   ),
                // }}
              />
            )}
          />
          <InputHelperText
            style={{ color: "red" }}
            text="Type postcode and number to search an address"
          />
        </FormControl>
      </Box>
      <Divider />
    </React.Fragment>
  );
});

function mapStateToProps(state: RootState) {
  const { addressPostcode } = createEntity(state);
  return { addressPostcode };
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(PostcodeForm);
